<template>
  <div>
    <b-modal
      size="xl"
      id="modalServiceTax"
      hide-footer
      hide-header
      @hidden="clear"
    >
      <div>
        <button class="closeModal" @click="$bvModal.hide('modalServiceTax')">
          <b-icon-x scale="1.3" />
        </button>
        <div class="contentTitle">
          <div class="title">
            <span>Cadastro de informações fiscais</span>
          </div>
        </div>

        <div class="containerTabs">
          <div class="containerItens">
            <div class="carroselCtn">
              <div class="StatementOnAccount">
                <label
                  v-for="item in tabs"
                  :key="item.text"
                  class="StatementOnAccountItem"
                  :class="{ active: selectedLabel === item.value }"
                  @click="storeLabelName(item.text)"
                >
                  {{ item.text }} <br />
                </label>
              </div>
            </div>
            <div v-show="selectedLabel === 'Geral'">
              <div class="contentDescription">
                <div class="description">
                  <p>Descrição</p>
                  <p style="color: red">*</p>
                </div>
                <textarea
                  :class="`inputTextArea ${isInvalidInput}`"
                  rows="3"
                  max-rows="6"
                  v-model="payload.descricao"
                  ref="descricao"
                  @blur="clearInvalidInput"
                />
                <p class="descriptionObs" style="margin-bottom: 0rem">
                  Descreva a classificação desse imposto para melhor
                  gerenciamento.
                </p>
              </div>
            </div>
            <div v-if="selectedLabel === 'Serviço'">
              <div class="rowContainer">
                <div class="rowContent">
                  <InputSelectInfinite
                    label="Código do Serviço*"
                    typeFilter="itens"
                    value="value"
                    text="text"
                    :dataInput.sync="payload.refObject.codigo_servico"
                    :onSearch="filterCodesServices"
                    :groupIds="true"
                    :enableIconCreate="false"
                    :filterIsEnable="false"
                  />

                  <InputSelectInfinite
                    label="Código NBS *"
                    typeFilter="itens"
                    value="value"
                    text="text"
                    :dataInput.sync="payload.refObject.codigo_nbs"
                    :onSearch="filterCodesNbs"
                    :groupIds="true"
                    :enableIconCreate="false"
                    :filterIsEnable="false"
                  />
                  <div class="selectPlus" style="width: 30%">
                    <label
                      class="fixedSelect"
                      style="font-size: 9px; bottom: 24px"
                      >Consumidor Final
                    </label>
                    <b-form-select
                      class="borderInput shadow-none"
                      value-field="value"
                      text-value="text"
                      v-model="payload.refObject.consumidor_final"
                      :options="consumidor"
                    >
                    </b-form-select>
                  </div>
                </div>
                <div class="rowContent">
                  <InputSelect
                    label="Tributação ISS*"
                    labelFixed
                    valueField="value"
                    textField="text"
                    :enableIconCreate="false"
                    :items="tributacaoIss"
                    :dataInput.sync="payload.refObject.tributacao_iss"
                    ref="tributacao_iss"
                    :isInvalidInput="isInvalidInput"
                    @clearInvalidInput="clearInvalidInput"
                  />
                  <div class="selectPlus">
                    <label class="fixedSelect"
                      >Código Indicador da Operação
                    </label>
                    <b-form-select
                      class="borderInput shadow-none"
                      value-field="value"
                      text-value="text"
                      v-model="payload.refObject.cod_indicador_operacao"
                      :options="codIndicadorOperacao"
                    >
                    </b-form-select>
                  </div>
                  <Input
                    label="Cód. Trib no município"
                    type="text"
                    labelFixed
                    ref="codigo_tributacao_municipio"
                    :dataInput.sync="
                      payload.refObject.codigo_tributacao_municipio
                    "
                    :isInvalidInput="isInvalidInput"
                    @clearInvalidInput="clearInvalidInput"
                  />
                  <Input
                    style="width: 30%"
                    label="Cód. CNAE"
                    type="text"
                    labelFixed
                    ref="codigo_cnae"
                    :dataInput.sync="payload.refObject.codigo_cnae"
                    :isInvalidInput="isInvalidInput"
                    @clearInvalidInput="clearInvalidInput"
                  />
                </div>
                <div style="display: flex; justify-content: start">
                  <label class="custom-checkbox">
                    <input v-model="othersInfos" name="dummy" type="checkbox" />
                    <span class="checkmark"></span>
                    Outras Informações
                  </label>
                </div>
                <div class="rowContent customSm" v-if="othersInfos">
                  <div class="selectPlus">
                    <label
                      class="fixedSelect"
                      style="font-size: 9px; bottom: 24px"
                      >Natureza da Operação *</label
                    >
                    <b-form-select
                      class="borderInput shadow-none"
                      value-field="value"
                      text-value="text"
                      v-model="payload.refObject.natureza_operacao"
                      :options="operationOptions"
                    >
                    </b-form-select>
                  </div>

                  <div class="selectPlus">
                    <label class="fixedSelect">Exigibilidade ISS *</label>
                    <b-form-select
                      class="borderInput shadow-none"
                      value-field="value"
                      text-value="text"
                      v-model="payload.refObject.exigibilidade_iss"
                      :options="issOptions"
                    >
                    </b-form-select>
                  </div>

                  <Input
                    label="Deduções %"
                    type="text"
                    labelFixed
                    :dataInput.sync="payload.refObject.deducao"
                    ref="deducao"
                    :isInvalidInput="isInvalidInput"
                    @clearInvalidInput="clearInvalidInput"
                  />
                  <div class="selectPlus">
                    <label class="fixedSelect">ISS Retido*</label>
                    <b-form-select
                      class="borderInput shadow-none"
                      value-field="value"
                      text-value="text"
                      v-model="payload.refObject.iss_retido"
                      :options="issRetidoOptions"
                      @change="handleSelectedItem"
                    >
                    </b-form-select>
                  </div>
                </div>
                <div
                  class="rowContent customSm"
                  v-if="payload.refObject.iss_retido === '1'"
                >
                  <div class="row-3">
                    <InputSelect
                      label="Responsavel Retenção iss *"
                      labelFixed
                      valueField="value"
                      textField="text"
                      :enableIconCreate="false"
                      :items="respRetencaoIssOptions"
                      :dataSelect.sync="payload.refObject.responsavel_retencao"
                      ref="responsavel_retencao"
                      :isInvalidInput="isInvalidInput"
                      @clearInvalidInput="clearInvalidInput"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div v-show="selectedLabel === 'Impostos'">
              <div
                class="rowContainer"
                style="gap: 10px !important; margin-bottom: 10px"
              >
                <div class="contentTax">
                  <div class="titleTax">
                    <span> IBS/CBS </span>
                    <div style="display: flex; justify-content: start">
                      <label
                        class="custom-checkbox"
                        style="margin: 0 !important"
                      >
                        <input
                          v-model="includeIbs"
                          name="dummy"
                          type="checkbox"
                        />
                        <span class="checkmark"></span>
                        Incluir ?
                      </label>
                    </div>
                  </div>
                  <div
                    v-show="includeIbs"
                    class="rowContent"
                    style="margin-bottom: 10px; padding: 0 10px"
                  >
                    <div class="selectPlus" style="width: 30%">
                      <label class="fixedSelect">Situação tributária**</label>
                      <b-form-select
                        class="borderInput shadow-none"
                        v-model="payload.refObject.ibs_cbs.situacao_tributaria"
                        :options="taxForSelectBoxes.ibs_cbs.situacao_tributaria"
                        value-field="value"
                        text-field="text"
                      >
                      </b-form-select>
                    </div>
                    <div class="selectPlus" style="width: 100% !important">
                      <label class="fixedSelect"
                        >Classificação Tributária**</label
                      >
                      <b-form-select
                        class="borderInput shadow-none"
                        v-model="
                          payload.refObject.ibs_cbs.classificacao_tributaria
                        "
                        :options="opcoesClassificacao"
                        value-field="value"
                        text-field="text"
                      >
                      </b-form-select>
                    </div>
                  </div>
                  <div
                    class="rowContent"
                    style="margin-bottom: 10px; padding: 0 10px"
                    v-if="
                      payload.refObject.ibs_cbs.situacao_tributaria === '510' &&
                      includeIbs
                    "
                  >
                    <div class="input-group-init">
                      <input
                        required
                        class="input borderInput"
                        v-model="
                          payload.refObject.ibs_cbs.ibs_estadual
                            .aliquota_diferimento
                        "
                      />
                      <label class="user-label">
                        IBS Estadual - Alíquota de Diferimento * %
                      </label>
                    </div>
                    <div class="input-group-init">
                      <input
                        required
                        class="input borderInput"
                        v-model="
                          payload.refObject.ibs_cbs.ibs_municipal
                            .aliquota_diferimento
                        "
                      />
                      <label class="user-label">
                        IBS Municipal - Alíquota de Diferimento * %
                      </label>
                    </div>
                    <div class="input-group-init">
                      <input
                        required
                        class="input borderInput"
                        v-model="
                          payload.refObject.ibs_cbs.cbs.aliquota_diferimento
                        "
                      />
                      <label class="user-label">
                        CBS - Alíquota de Diferimento * %
                      </label>
                    </div>
                  </div>
                </div>
                <div class="contentTax">
                  <div class="titleTax">
                    <span> ISS </span>
                    <div style="display: flex; justify-content: start">
                      <label
                        class="custom-checkbox"
                        style="margin: 0 !important"
                      >
                        <input
                          v-model="includeIss"
                          name="dummy"
                          type="checkbox"
                        />
                        <span class="checkmark"></span>
                        Incluir ?
                      </label>
                    </div>
                  </div>
                  <div
                    v-show="includeIss"
                    class="rowContent"
                    style="margin-bottom: 10px; padding: 0 10px"
                  >
                    <InputSelect
                      label="Retenção*"
                      labelFixed
                      valueField="value"
                      textField="text"
                      :enableIconCreate="false"
                      :items="respRetencaoIssOptions"
                      :dataSelect.sync="payload.refObject.responsavel_retencao"
                      ref="responsavel_retencao"
                      :isInvalidInput="isInvalidInput"
                      @clearInvalidInput="clearInvalidInput"
                    />
                    <InputPercentage
                      label="ISS"
                      type="text"
                      labelFixed
                      :dataInput.sync="payload.refObject.iss"
                      ref="iss"
                      :isInvalidInput="isInvalidInput"
                      @clearInvalidInput="clearInvalidInput"
                    />
                  </div>
                </div>
                <div class="contentTax">
                  <div class="titleTax">
                    <span> PIS/COFINS </span>
                    <div style="display: flex; justify-content: start">
                      <label
                        class="custom-checkbox"
                        style="margin: 0 !important"
                      >
                        <input
                          v-model="includePisCofins"
                          name="dummy"
                          type="checkbox"
                        />
                        <span class="checkmark"></span>
                        Incluir ?
                      </label>
                    </div>
                  </div>
                  <div
                    v-show="includePisCofins"
                    class="rowContent"
                    style="margin-bottom: 10px; padding: 0 10px"
                  >
                    <InputSelect
                      label="Situação Tributária *"
                      labelFixed
                      valueField="value"
                      textField="text"
                      :enableIconCreate="false"
                      :items="cstPisCofins"
                      :dataSelect.sync="payload.refObject.cst_pis_cofins"
                      ref="cst_pis_cofins"
                      :isInvalidInput="isInvalidInput"
                      @clearInvalidInput="clearInvalidInput"
                    />
                    <InputSelect
                      label="ISS Retido *"
                      labelFixed
                      valueField="value"
                      textField="text"
                      :enableIconCreate="false"
                      :items="issRetidoOptions"
                      :dataSelect.sync="payload.refObject.iss_retido"
                      ref="iss_retido"
                      :isInvalidInput="isInvalidInput"
                      @clearInvalidInput="clearInvalidInput"
                      @selectedIten="handleSelectedItem"
                    />
                    <InputPercentage
                      label="PIS"
                      type="text"
                      labelFixed
                      :dataInput.sync="payload.refObject.pis"
                      ref="pis"
                      :isInvalidInput="isInvalidInput"
                      @clearInvalidInput="clearInvalidInput"
                    />

                    <InputPercentage
                      label="COFINS"
                      type="text"
                      labelFixed
                      :dataInput.sync="payload.refObject.cofins"
                      ref="cofins"
                      :isInvalidInput="isInvalidInput"
                      @clearInvalidInput="clearInvalidInput"
                    />
                  </div>
                </div>
                <div class="contentTax">
                  <div class="titleTax">
                    <span> OUTROS </span>
                    <div style="display: flex; justify-content: start">
                      <label
                        class="custom-checkbox"
                        style="margin: 0 !important"
                      >
                        <input
                          v-model="includeOthers"
                          name="dummy"
                          type="checkbox"
                        />
                        <span class="checkmark"></span>
                        Incluir ?
                      </label>
                    </div>
                  </div>
                  <div
                    v-show="includeOthers"
                    class="rowContent"
                    style="margin-bottom: 10px; padding: 0 10px"
                  >
                    <InputPercentage
                      style="width: 15%"
                      label="IR"
                      type="text"
                      labelFixed
                      :dataInput.sync="payload.refObject.ir"
                      ref="ir"
                      :isInvalidInput="isInvalidInput"
                      @clearInvalidInput="clearInvalidInput"
                    />

                    <InputPercentage
                      style="width: 15%"
                      label="CSLL"
                      type="text"
                      labelFixed
                      :dataInput.sync="payload.refObject.csll"
                      ref="csll"
                      :isInvalidInput="isInvalidInput"
                      @clearInvalidInput="clearInvalidInput"
                    />
                    <InputPercentage
                      label="INSS"
                      type="text"
                      labelFixed
                      :dataInput.sync="payload.refObject.inss"
                      ref="inss"
                      :isInvalidInput="isInvalidInput"
                      @clearInvalidInput="clearInvalidInput"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div v-show="selectedLabel === 'Pesquisar'">
              <div class="rowContainer">
                <div class="contentTable">
                  <div class="headerTable">
                    <div class="celTable" style="width: 35%">REF</div>
                    <div class="celTable" style="width: 50%">Descrição</div>
                    <div class="celTableActions">Ações</div>
                  </div>
                  <div
                    v-for="ref in refsNfse"
                    :key="ref.id"
                    :class="`rowSupplier`"
                  >
                    <div class="celTable" style="width: 35%">
                      {{ ref.ref }}
                    </div>
                    <div class="celTable" style="width: 50%">
                      {{ ref.descricao }}
                    </div>
                    <div class="celTableActions">
                      <span
                        style="font-size: 10px !important"
                        class="celInfos"
                        @click="edit(ref.id)"
                        ><b-icon-pencil-square scale="1.5"
                      /></span>
                      <span
                        style="font-size: 10px !important"
                        class="celInfos"
                        @click="remove(ref)"
                        ><b-icon-trash-fill scale="1.5"
                      /></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="generalLoading" v-if="generalSpin">
            <b-spinner class="generalSpin" />
          </div>
        </div>

        <div class="contentButtons">
          <b-button class="defaultBtn btnNew" @click="clear"
            >Novo <b-icon-arrow-clockwise class="ml-1"
          /></b-button>

          <b-button class="defaultBtn" @click="handleSaveOrUpdate">
            {{ payload.id ? "Atualizar" : "Salvar" }}
            <b-icon-check2-circle class="ml-1"
          /></b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Input from "../UI/CustomInputs/Input.vue";
import InputPercentage from "../UI/CustomInputs/InputPercentage.vue";
import InputSelect from "../UI/CustomInputs/InputSelect.vue";
import ServiceTaxNfse from "../../services/serviceTaxNfse";
import { ValidadeTaxService } from "../../validators/taxNfse";
import { INITIAL_STATE_DATA_REF } from "../../initialStates/serviceTax";
import { codesService, codesNbs } from "../../common/index";
import { mapState } from "vuex";
import InputSelectInfinite from "../UI/CustomInputs/InputInfinit.vue";
import {
  initialStateInfoFiscal,
  initialStateTaxForSelectBoxes,
  cstPisCofins,
} from "../../initialStates/infoFiscal";

export default {
  props: {
    refsNfse: {
      type: Array,
    },
  },
  components: {
    Input,
    InputPercentage,
    InputSelect,
    InputSelectInfinite,
  },
  data() {
    return {
      infoFiscal: initialStateInfoFiscal,
      taxForSelectBoxes: initialStateTaxForSelectBoxes,
      codesService: codesService,
      cstPisCofins: cstPisCofins,
      codesNbs: codesNbs,
      payload: {
        id: "",
        descricao: "",
        ref: "",
        refObject: {
          tipo_emissao: 1,
          finalidade: 0,
          codigo_servico: "",
          natureza_operacao: "",
          exigibilidade_iss: "",
          iss_retido: "",
          codigo_cnae: "",
          codigo_tributacao_municipio: "",
          cod_indicador_operacao: "",
          consumidor_final: "",
          responsavel_retencao: "",
          codigo_nbs: "",
          tributacao_iss: "1",
          cst_pis_cofins: "00",
          ibs_cbs: {
            situacao_tributaria: null,
            classificacao_tributaria: null,
            ibs_estadual: {
              aliquota_diferimento: "",
            },
            ibs_municipal: {
              aliquota_diferimento: "",
            },
            cbs: {
              aliquota_diferimento: "",
            },
          },
          tipo: "nfse",
          iss: 0,
          pis: 0,
          cofins: 0,
          inss: 0,
          ir: 0,
          csll: 0,
          deducao: "",
        },
      },
      operationOptions: [
        { value: "", text: "--- Selecione uma opção ---" },
        { value: "1", text: "Tributação no município" },
        { value: "2", text: "Tributação fora do município" },
        { value: "3", text: "Isenção" },
        { value: "4", text: "Imune" },
        { value: "5", text: "Exigibilidade suspensa por decisão judicial" },
        {
          value: "6",
          text: "Exigibilidade suspensa por procedimento administrativo",
        },
      ],
      issOptions: [
        { value: "", text: "--- Selecione uma opção ---" },
        { value: "1", text: "Exigível" },
        { value: "2", text: "Não incidência" },
        { value: "3", text: "Isenção" },
        { value: "4", text: "Exportação" },
        { value: "5", text: "Imunidade" },
        { value: "6", text: "Exigibilidade suspensa por decisão judicial" },
        {
          value: "7",
          text: "Exigibilidade suspensa por processo administrativo",
        },
      ],
      issRetidoOptions: [
        { value: "", text: "--- Selecione uma opção ---" },
        { value: "1", text: "Sim" },
        { value: "2", text: "Não" },
      ],
      respRetencaoIssOptions: [
        { value: "", text: "--- Selecione uma opção ---" },
        { value: "1", text: "Tomador" },
        { value: "2", text: "Intermediário" },
      ],
      tributacaoIss: [
        { value: "1", text: "Operação tributável" },
        { value: "2", text: "Imunidade" },
        { value: "4", text: "Não Incidência" },
      ],
      finalidades: [
        { value: "0", text: "Normal" },
        { value: "1", text: "Nota substituta" },
        { value: "2", text: "Nota complementar" },
      ],
      tipoOperacao: [
        { value: "1", text: "Fornecimento com pagamento posterior" },
        {
          value: "2",
          text: "Recebimento do pagamento com fornecimento já realizado",
        },
        { value: "3", text: "Fornecimento com pagamento já realizado" },
        {
          value: "4",
          text: "Recebimento do pagamento com fornecimento posterior",
        },
        {
          value: "5",
          text: "Fornecimento e recebimento do pagamento concomitantes",
        },
      ],
      consumidor: [
        { value: "0", text: "Não" },
        { value: "1", text: "Sim" },
      ],
      codIndicadorOperacao: [
        {
          value: "020101",
          text: "020101 - Operação com bem imóvel, bem imaterial, inclusive direito,  relacionada a bem imóvel",
        },
        {
          value: "020201",
          text: "020201 - Serviço prestado fisicamente sobre bem imóvel",
        },
        {
          value: "020301",
          text: "020301 - Serviço de administração e intermediação de bem imóvel",
        },
        {
          value: "030101",
          text: "030101 - Serviço prestado fisicamente sobre a pessoa ou fruído presencialmente por pessoa física no estabelecimento do fornecedor",
        },
        {
          value: "030102",
          text: "030102 - Serviço prestado fisicamente sobre a pessoa ou fruído presencialmente por pessoa física no endereço do adquirente",
        },
        {
          value: "030103",
          text: "030103 - Serviço prestado fisicamente sobre a pessoa ou fruído presencialmente por pessoa física no endereço do destinatário",
        },
        {
          value: "030104",
          text: "030104 - Serviço prestado fisicamente sobre a pessoa ou fruído presencialmente por pessoa física no endereço diverso do fornecedor, adquirente ou destinatário",
        },
        {
          value: "040101",
          text: "040101 - Serviço de planejamento, organização e administração de feiras, exposições, congressos, espetáculos, exibições e congêneres",
        },
        {
          value: "050101",
          text: "050101 - Serviço prestado fisicamente sobre bem móvel material no estabelecimento do fornecedor",
        },
        {
          value: "050102",
          text: "050102 - Serviço prestado fisicamente sobre bem móvel material no endereço do adquirente",
        },
        {
          value: "050103",
          text: "050103 - Serviço prestado fisicamente sobre bem móvel material no endereço do destinatário",
        },
        {
          value: "050104",
          text: "050104 - Serviço prestado fisicamente sobre bem móvel material no endereço diverso do fornecedor, adquirente ou destinatário",
        },
        { value: "050201", text: "050201 - Serviços portuários" },
        {
          value: "060101",
          text: "060101 - Serviço de transporte de passageiros",
        },
        {
          value: "070101",
          text: "070101 - Serviço de transporte de carga no endereço fornecido para entrega",
        },
        {
          value: "070102",
          text: "070102 - Serviço de transporte de carga no local da retirada",
        },
        { value: "080101", text: "080101 - Serviço de exploração de via" },
        {
          value: "100101",
          text: "100101 - Cessão de espaço para prestação de serviços publicitários, em operações onerosas no local do domicílio principal do adquirente",
        },
        {
          value: "100102",
          text: "100102 - Cessão de espaço para prestação de serviços publicitários, em operações onerosas no local do domicílio do destinatário, nos casos de adquirente residente ou domiciliado no exterior",
        },
        {
          value: "100201",
          text: "100201 - Cessão de espaço para prestação de serviços publicitários, em operações não onerosas",
        },
        {
          value: "100301",
          text: "100301 - Demais serviços, em operações onerosas no local do domicílio principal do adquirente",
        },
        {
          value: "100302",
          text: "100302 - Demais serviços, em operações onerosas no local do domicílio do destinatário, nos casos de adquirente residente ou domiciliado no exterior",
        },
        {
          value: "100401",
          text: "100401 - Demais serviços, em operações não onerosas",
        },
        {
          value: "100501",
          text: "100501 - Demais bens móveis imateriais, inclusive direitos, em operações onerosas no local do domicílio principal do adquirente",
        },
        {
          value: "100502",
          text: "100502 - Demais bens móveis imateriais, inclusive direitos, em operações onerosas no local do domicílio do destinatário, nos casos de adquirente residente ou domiciliado no exterior",
        },
        {
          value: "100601",
          text: "100601 - Demais bens móveis imateriais, inclusive direitos, em operações não onerosas",
        },
      ],
      isInvalidInput: "",
      generalSpin: false,
      othersInfos: false,
      includeIbs: false,
      includeIss: false,
      includePisCofins: false,
      includeOthers: false,
      selectedLabel: "Geral",
      toggleClearSelect: false,
    };
  },

  methods: {
    async storeLabelName(labelName) {
      this.selectedLabel = labelName;
    },
    filterPayload() {
      const payloadToSend = JSON.parse(JSON.stringify(this.payload));
      const ref = payloadToSend.refObject;
      const cleanRefObject = {
        tipo: "nfse",
        codigo_servico: ref.codigo_servico,
        consumidor_final: ref.consumidor_final,
        cod_indicador_operacao: ref.cod_indicador_operacao,
        tributacao_iss: ref.tributacao_iss || "1",
      };
      if (ref.consumidor_final === "") {
        delete cleanRefObject.consumidor_final;
      }
      if (ref.codigo_cnae === "") {
        delete cleanRefObject.codigo_cnae;
      }
      if (ref.cod_indicador_operacao === "") {
        delete cleanRefObject.cod_indicador_operacao;
      }
      cleanRefObject.tipo_emissao = ref.tipo_emissao;
      cleanRefObject.codigo_nbs = ref.codigo_nbs;
      cleanRefObject.codigo_cnae = ref.codigo_cnae;
      cleanRefObject.codigo_tributacao_municipio =
        ref.codigo_tributacao_municipio;

      if (this.othersInfos) {
        cleanRefObject.natureza_operacao = ref.natureza_operacao;
        cleanRefObject.exigibilidade_iss = ref.exigibilidade_iss;
        cleanRefObject.deducao = ref.deducao;
        cleanRefObject.iss_retido = ref.iss_retido;

        if (ref.iss_retido === "1") {
          cleanRefObject.responsavel_retencao = ref.responsavel_retencao;
        }
      }

      if (this.includeIbs) {
        cleanRefObject.ibs_cbs = {
          situacao_tributaria: ref.ibs_cbs.situacao_tributaria,
          classificacao_tributaria: ref.ibs_cbs.classificacao_tributaria,
        };

        if (ref.ibs_cbs.situacao_tributaria === "510") {
          cleanRefObject.ibs_cbs.ibs_estadual = {
            aliquota_diferimento: ref.ibs_cbs.ibs_estadual.aliquota_diferimento,
          };
          cleanRefObject.ibs_cbs.ibs_municipal = {
            aliquota_diferimento:
              ref.ibs_cbs.ibs_municipal.aliquota_diferimento,
          };
          cleanRefObject.ibs_cbs.cbs = {
            aliquota_diferimento: ref.ibs_cbs.cbs.aliquota_diferimento,
          };
        }
      }

      if (this.includeIss) {
        cleanRefObject.iss = ref.iss;
        if (!cleanRefObject.responsavel_retencao) {
          cleanRefObject.responsavel_retencao = ref.responsavel_retencao;
        }
      }

      if (this.includePisCofins) {
        cleanRefObject.cst_pis_cofins = ref.cst_pis_cofins;
        cleanRefObject.pis = ref.pis;
        cleanRefObject.cofins = ref.cofins;
      }

      if (this.includeOthers) {
        cleanRefObject.ir = ref.ir;
        cleanRefObject.csll = ref.csll;
        cleanRefObject.inss = ref.inss;
      }

      payloadToSend.refObject = cleanRefObject;
      return payloadToSend;
    },
    async save() {
      try {
        this.generalSpin = true;
        const isNotValid = ValidadeTaxService(this.payload);
        if (isNotValid && Object.keys(isNotValid).length) {
          await this.$nextTick();
          this.handleFocus(isNotValid.keyError);
          return this.$toast.open({
            message: isNotValid.message,
            type: "info",
          });
        }

        const payloadToSend = this.filterPayload();

        const id = await ServiceTaxNfse.save(payloadToSend);
        this.payload.id = id;

        this.clear();
        this.$toast.open({
          message: "Novo imposto registrado",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message: error?.response?.data?.message,
          type: "info",
        });
      } finally {
        this.generalSpin = false;
      }
    },

    async update() {
      try {
        this.generalSpin = true;
        const isNotValid = ValidadeTaxService(this.payload);
        if (isNotValid && Object.keys(isNotValid).length) {
          await this.$nextTick();
          this.handleFocus(isNotValid.keyError);
          return this.$toast.open({
            message: isNotValid.message,
            type: "info",
          });
        }
        const payloadToSend = this.filterPayload();
        await ServiceTaxNfse.update(payloadToSend);
        this.$toast.open({
          message: "Imposto atualizado",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message || "Ocorreu um erro ao atualizar",
          type: "info",
        });
      } finally {
        this.generalSpin = false;
      }
    },

    async edit(id) {
      try {
        this.payload = await ServiceTaxNfse.findById(id);
        this.selectedLabel = "Geral";
        this.assingValues();
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um erro ao buscar esse REF",
          type: "info",
        });
      }
    },

    async remove(dataRef) {
      try {
        this.generalSpin = true;
        await ServiceTaxNfse.delete(dataRef);
        this.$emit("baseActionsRef");

        this.$toast.open({
          message: "REF removido!",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um erro ao deletar esse REF",
          type: "info",
        });
      } finally {
        this.generalSpin = false;
      }
    },

    async handleSaveOrUpdate() {
      this.payload.id ? await this.update() : await this.save();
      this.$emit("baseActionsRef");
    },

    assingValues() {
      Object.keys(this.$refs).forEach((key) => {
        if (this.$refs[key]) {
          if (key === "descricao") {
            this.$refs[key].valueInput = this.payload[key];
          } else {
            if ("valueItems" in this.$refs[key])
              this.$refs[key].valueItems = this.payload.refObject[key];

            if ("valueInput" in this.$refs[key])
              this.$refs[key].valueInput = this.payload.refObject[key];
          }
        }
      });
      const ref = this.payload.refObject;
      this.includeIss = !!ref.iss;
      this.includePisCofins = ref.cst_pis_cofins !== "00" && !!ref.pis;
      this.includeOthers = !!(ref.ir || ref.csll || ref.inss);
      this.includeIbs = !!(ref.ibs_cbs && ref.ibs_cbs.situacao_tributaria);
      this.othersInfos = !!(ref.natureza_operacao || ref.iss_retido);
    },
    async filterCodesServices(y, q) {
      try {
        const services = codesService.filter((item) =>
          item.text.toLowerCase().startsWith(q.toLowerCase())
        );
        return services;
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao listar os produtos",
          type: "info",
        });
      }
    },
    async filterCodesNbs(y, q) {
      try {
        const nbs = codesNbs.filter((item) =>
          item.text.toLowerCase().startsWith(q.toLowerCase())
        );
        return nbs;
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao listar os produtos",
          type: "info",
        });
      }
    },
    handleFocus(refName) {
      if (refName === "descricao") {
        this.$refs[refName].focus();
      } else if ("textField" in this.$refs[refName]) {
        this.$refs[refName].$children[0].focus();
      } else {
        this.$refs[refName].$el.children[0].focus();
      }

      this.isInvalidInput = "isInvalidInput";
    },

    clearInvalidInput() {
      this.isInvalidInput = "";
    },

    clear() {
      this.payload = JSON.parse(JSON.stringify(INITIAL_STATE_DATA_REF));
      this.clearRefs();
    },

    clearRefs() {
      Object.keys(this.$refs).forEach((key) => {
        if (this.$refs[key]) {
          if (this.$refs[key].valueItems) this.$refs[key].valueItems = "";
          if (this.$refs[key].valueInput) this.$refs[key].valueInput = "";
        }
      });
    },
    handleSelectedItem(selectedValue) {
      if (selectedValue === "2") {
        delete this.payload.refObject.responsavel_retencao;
      }
    },
    formatSelectOptions(items, maxLength = 80) {
      if (!items || !Array.isArray(items)) return [];

      return items.map((item) => {
        if (typeof item === "string") {
          return item.length > maxLength
            ? item.substring(0, maxLength) + "..."
            : item;
        }

        if (typeof item === "object") {
          const newItem = { ...item };
          const textKey = "text";
          const text = newItem[textKey];

          if (text && text.length > maxLength) {
            newItem[textKey] = text.substring(0, maxLength) + "...";
            newItem.title = text;
          }
          return newItem;
        }

        return item;
      });
    },
  },
  computed: {
    ...mapState({
      dataCompany: (state) => state.dataCompany,
    }),
    opcoesClassificacao() {
      const ibsCbs = this.payload?.refObject?.ibs_cbs;
      if (!ibsCbs || !ibsCbs.situacao_tributaria) return [];
      const chave = `sit${ibsCbs.situacao_tributaria}`;
      return this.taxForSelectBoxes.ibs_cbs[chave] || [];
    },
    tabs() {
      const allTabs = [
        { value: "Geral", text: "Geral" },
        { value: "Serviço", text: "Serviço" },
        { value: "Impostos", text: "Impostos" },
        { value: "Pesquisar", text: "Pesquisar" },
      ];
      return allTabs;
    },
  },
  watch: {
    opcoesClassificacao(novasOpcoes) {
      if (this.payload.refObject && !this.payload.refObject.ibs_cbs) {
        this.$set(this.payload.refObject, "ibs_cbs", {
          situacao_tributaria: null,
          classificacao_tributaria: null,
        });
      }

      const ibsCbs = this.payload.refObject.ibs_cbs;

      if (novasOpcoes && novasOpcoes.length > 0) {
        const atual = ibsCbs.classificacao_tributaria;

        if (!novasOpcoes.find((o) => o.value === atual)) {
          ibsCbs.classificacao_tributaria = novasOpcoes[0].value;
        }
      } else {
        ibsCbs.classificacao_tributaria = null;
      }
    },
  },
};
</script>

<style scoped>
.closeModal {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1000;
  color: rgb(255, 153, 153);
  cursor: pointer;
  border: 1px solid rgb(238, 238, 238);
  padding: 2px 3px;
  border-radius: 4px;
}

.closeModal:hover {
  color: red;
  background: rgba(245, 245, 245, 0.764);
}

.title {
  font-size: 16px;
  color: rgb(95, 95, 95);
  margin-bottom: 0px;
  font-weight: 600;
}
.contentTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px 0px 0;
  margin-bottom: 10px;
}
.contentTax {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  border: 1px solid #dadada;
  border-radius: 4px;
}
.titleTax {
  display: flex;
  padding: 5px;
  text-align: center;
  background: #eaeaea;
  border-radius: 4px 4px 0 0;
  border-bottom: 2px solid #c7c7c7;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
.titleTax span {
  width: 90%;
  font-size: 14px;
  color: #006256;
  font-weight: 600;
}
.containerItens {
  padding: 0 15px;
  min-height: 350px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.carroselCtn {
  display: flex;
  gap: 10px;
  background: #fdfdfd;
  border-bottom: 1px dashed #7c7c7d;
  padding: 0px 10px 0 10px;
  border-radius: 5px 5px 0 0;
}

.StatementOnAccount {
  display: flex;
  align-items: flex-end;
  padding-top: 10px;
  width: 100%;
  gap: 10px;
  transition: transform 0.5s ease-in-out;
}
.StatementOnAccount ::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.StatementOnAccount::-webkit-scrollbar-track {
  background: white;
}

.StatementOnAccount::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 2px;
}

.StatementOnAccountItem {
  height: 30px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 0 30px;
  background: #e4e4e4;
  color: #006256;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  text-transform: capitalize;
  transition: background-color 0.3s ease, color 0.3s ease,
    border-bottom 0.3s ease, height 0.3s ease, padding-bottom 0.3s ease,
    transform 0.3s ease;
}

.StatementOnAccountItem p {
  font-weight: 600;
}

.StatementOnAccountItem.active {
  height: 31px;
  background-color: #ffffff;
  color: #000;
  border-bottom: 4px solid #000;
  padding-bottom: 1px;
  transform: translateY(-4px);
}

.StatementOnAccountItem:hover {
  background-color: #ececec;
  color: #000;
}

.StatementOnAccountItem:focus {
  background: #000;
  color: white;
  border-bottom: 3px solid #ff0040 !important;
  outline: none;
}

.btnBack {
  border-radius: 5px;
  background-color: #006256;
  border: none;
  margin-top: 30px;
  color: white;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-size: 13px;
  width: 150px;
  font-size: 18px;
  margin-top: 0;
}

.contentDescription {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.selectPlus {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}
.fixedSelect {
  position: absolute;
  margin-bottom: 0px;
  font-size: 10px;
  bottom: 23px;
  left: 10px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(102, 98, 98);
  background-color: rgb(255, 255, 255);
  font-weight: 600;
}
.custom-select:disabled {
  color: black;
  background-color: #d5d3d3;
}

.custom-select {
  background: none;
  text-transform: capitalize;
}
.user-label {
  position: absolute;
  left: 10px;
  font-size: 12px;
  bottom: 4px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}
.input-group-init {
  width: 33%;
  position: relative;
}
.input {
  font-size: 12px !important;
  width: 100%;
}

.input:focus ~ label,
input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.1em;
  font-weight: 600;
}
.borderInput {
  font-size: 13px;
  height: 30px;
  border: 1px solid #d5d3d3;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.borderInput:focus {
  border: 1px solid #505050;
}
.BleedingChk {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  z-index: 10;
}
/*  */
.radio-label {
  font-size: 12px;
  color: #333;
}
.radio-button {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  cursor: pointer;
}

.radio-button input[type="radio"] {
  display: none;
}

.radio-circle {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 2px solid #aaa;
  position: relative;
  margin-right: 5px;
}

.radio-circle::before {
  content: "";
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: #ddd;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0);
  transition: all 0.2s ease-in-out;
}

.radio-button input[type="radio"]:checked + .radio-circle::before {
  transform: translate(-50%, -50%) scale(1);
}

.radio-button:nth-of-type(1)
  input[type="radio"]:checked
  + .radio-circle::before {
  background-color: #006256;
}

.radio-button:nth-of-type(2)
  input[type="radio"]:checked
  + .radio-circle::before {
  background-color: #006256;
}

.radio-button:hover .radio-circle {
  border-color: #006256;
}

.radio-button:hover input[type="radio"]:checked + .radio-circle::before {
  background-color: #006256;
}
.description {
  display: flex;
  gap: 5px;
}

.description p {
  margin: 0px;
  font-size: 13px;
  color: #666360;
  font-weight: 600;
  font-family: Poppins-Regular, sans-serif !important;
}

.descriptionObs {
  color: #666360a3;
  font-size: 12px;
}

.inputTextArea {
  width: 100%;
  border: none;
  outline: none;
  text-decoration: none;
  background-color: white;
  color: #5c5855;
  border-radius: 5px;
  height: 80px;
  padding: 5px;
  border: solid 1px #d9d9d9;
  resize: none;
  font-size: 12px;
}
.custom-checkbox {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  font-size: 11px;
  color: #333;
  transition: color 0.3s;
}

.custom-checkbox input[type="checkbox"] {
  display: none;
}

.custom-checkbox .checkmark {
  width: 14px;
  height: 14px;
  border: 2px solid #333;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 4px;
  transition: background-color 0.3s, border-color 0.3s, transform 0.3s;
  transform-style: preserve-3d;
}

.custom-checkbox .checkmark::before {
  content: "\2713";
  font-size: 12px;
  color: transparent;
  transition: color 0.3s, transform 0.3s;
}

.custom-checkbox input[type="checkbox"]:checked + .checkmark {
  background-color: #006256;
  border-color: #333;
  transform: scale(1.1) rotateZ(360deg) rotateY(360deg);
}

.custom-checkbox input[type="checkbox"]:checked + .checkmark::before {
  color: #f0f0f0;
}

.custom-checkbox:hover {
  color: #666;
}

.custom-checkbox:hover .checkmark {
  border-color: #666;
  background-color: #f0f0f0;
  transform: scale(1.05);
}

.custom-checkbox input[type="checkbox"]:focus + .checkmark {
  box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.2);
  outline: none;
}

.custom-checkbox .checkmark,
.custom-checkbox input[type="checkbox"]:checked + .checkmark {
  transition: background-color 1.3s, border-color 1.3s, color 1.3s,
    transform 0.3s;
}
.containerTabs {
  position: relative;
  border: solid 1px rgba(128, 128, 128, 0.39);
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.316) !important;
  border-radius: 5px !important;
}

.rowContainer {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.rowContent {
  display: flex;
  gap: 1rem;
}

.row-1 {
  width: 100%;
}

.row-2 {
  width: 100%;
}

.contentButtons {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}

.defaultBtn {
  border-radius: 5px;
  background-color: #006256;
  width: 165px;
  border: none;
  margin-top: 5px;
  color: white;
  font-size: 12px;
  font-weight: normal;
}

.defaultBtn:hover {
  background-color: #002841;
}

.defaultBtn:focus {
  background-color: #006256;
}

.btnNew {
  background-color: rgb(182, 182, 182);
}

.btnNew:hover {
  background-color: rgb(157, 157, 157);
}

.btnNew:focus {
  background-color: rgb(157, 157, 157);
}

.isInvalidInput:focus {
  border: solid 1px rgba(204, 21, 21, 0.583) !important;
  transition: ease-in all 0.1s;
  box-shadow: 0 0 2px 1px rgba(204, 21, 21, 0.583) !important;
}

.delBill {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
}

.btnRef {
  border: none;
  width: 25px;
  height: 25px;
  border-radius: 50%;
}

.contentTable {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: auto;
  gap: 1px;
  width: 100%;
  min-height: 300px;
  max-width: 100%;
}
.headerTable {
  border-radius: 5px 5px 0 0;
  width: 100%;
  display: flex;
  align-items: center;
  height: 30px;
  background: #006256;
  color: whitesmoke;
  font-weight: bold;
  font-size: 14px;
}
.rowSupplier {
  width: 100%;
  display: flex;
  align-items: center;
  background: #f8f8f8;
  border: 1px solid rgb(226, 226, 226);
  border-radius: 2px;
  text-align: center;
  height: 35px;
  padding: 0;
  cursor: context-menu;
  color: #313131;
  font-size: 12px;
}

.rowSupplier:hover {
  background: rgb(242, 242, 242);
  cursor: pointer;
}

.celTable {
  display: flex;
  flex-direction: column;
  text-align: center;
}

.celTableActions {
  display: flex;
  gap: 10px;
  width: 10%;
  text-align: center;
  justify-content: center;
  align-items: center;
}

.celInfos {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #006256;
  border-radius: 5px;
  height: 30px;
  width: 30px;
  font-size: 10px !important;
  font-weight: 100 !important;
  color: white;
}
.generalSpin {
  width: 60px;
  height: 60px;
}

.generalLoading {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(128, 128, 128, 0.294);
  z-index: 9999;
}

@media screen and (max-width: 991px) {
  .customSm {
    flex-wrap: wrap;
  }

  .rowContainer {
    gap: 1rem;
  }

  .containerTabs {
    height: auto;
  }
}

@media screen and (max-width: 500px) {
  .rowContent {
    flex-wrap: wrap;
  }
}
</style>